"use client";

import { getTitleFromPath } from "@/lib/utils";
import { usePathname } from "next/navigation";

export default function Header() {
  const pathname = usePathname();
  const title = getTitleFromPath(pathname);

  return (
    <div className="fixed w-full flex gap-4 p-4 border-b items-center justify-between bg-white">
       {title}
    </div>
  );
}
